<template>
  <div class="addPackageWrapper">
    <q-form @submit="onSubmit" class="form">
      <div class="form__item">
        <CustomInput label="Наименование набора" :value="formData.set_name"
          @change_input="(value) => onChange('set_name', value)" style="width: 100%;" :showClearIcon="false" />
      </div>
      <div v-for="material in formData.materials" :key="material.material_id || material.material_id_new"
        class="material-card" :class="{ 'material-card--main': material.is_main }">
        <template v-if="material.is_main">
          <div class="material-card__title">Основной материал</div>
          <div class="form-grid form-grid--main">
            <div class="form__item">
              <div class="readonly-group">
                <div class="readonly-label">Материал - ID: {{ material.material_id }}</div>
                <div class="readonly-value">{{ material.material_name }}</div>
              </div>
            </div>
            <div class="form__item">
              <CustomInput label="Формула" :value="material.formula"
                @change_input="(value) => updateMaterialByKey(material.material_id, 'formula', value)"
                style="width: 100%;" :showClearIcon="false" />
            </div>
            <div class="form__item">
              <CustomInput label="Расход" :value="material.consumption"
                @change_input="(value) => updateMaterialByKey(material.material_id, 'consumption', value)"
                style="width: 100%;" :showClearIcon="false" />
            </div>
          </div>
        </template>

        <template v-else>
          <div class="form-grid">
            <div class="form__item">
              <CustomInputDropdown :label="material.material_id ? `Материал - ID: ${material.material_id}` : 'Материал'"
                :options="materialOptions[material.material_id] || []" optionValueKey="material_id"
                optionLabelKey="label"
                :value="materialSearchValues[material.material_id] !== undefined ? materialSearchValues[material.material_id] : (material.material_name || '')"
                :loading="materialLoading[material.material_id] || false" :clearable="false"
                @change_input="(value) => onMaterialSearch(material.material_id, value)"
                @select_item="(_val, row) => onMaterialSelect(material.material_id, row)" style="width: 100%;" />
            </div>
            <div class="form__item">
              <CustomInput label="Формула" :value="material.formula"
                @change_input="(value) => updateMaterialByKey(material.material_id || material.material_id_new, 'formula', value)"
                style="width: 100%;" :showClearIcon="false" />
            </div>
            <div class="form__item">
              <CustomInput label="Расход" :value="material.consumption"
                @change_input="(value) => updateMaterialByKey(material.material_id || material.material_id_new, 'consumption', value)"
                style="width: 100%;" :showClearIcon="false" />
            </div>
            <div class="form__actions">
              <CustomIcon icon="trash" title="Удалить"
                @click="removeMaterial(material.material_id, material.material_id_new)" :showClearIcon="false" />
            </div>
          </div>
        </template>
      </div>
      <div class="addIcon">
        <Clickable @click="addMaterial" :class="{ 'unclickable': !formData.materials.at(-1).material_id }">
          Добавить
          <CustomIcon icon="add" title="Добавить" />
        </Clickable>
      </div>
      <CustomModalFooter :btn-loading="loading" />
    </q-form>
  </div>
</template>

<script>
import CustomCheckbox from "@/components/form/CustomCheckbox";
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomInput from "@/components/form/CustomInput";
import CustomSelect from "@/components/form/CustomSelect";
import CustomInputDropdown from "@/components/form/CustomInputDropdown";
import CustomIcon from "@/components/common/CustomIcon";
import Clickable from "@/components/common/Clickable";
import { getSetInfo, searchMaterials } from "@/views/PackageEntry/services"
import { deleteMaterial } from "@/views/PackageList/services"

export default {
  name: "upd-set",
  components: { CustomCheckbox, CustomModalFooter, CustomInput, CustomSelect, CustomIcon, Clickable, CustomInputDropdown },
  props: ["data"],
  data() {
    return {
      loading: false,
      residencyOptions: [],
      isItemMain: false,
      formData: {
        set_name: this.data?.body?.set_name || "",
        material_set_id: this.data?.body?.material_set_id || "",
        materials: this.data?.body?.materials || [
          {
            material_id: "",
            material_id_new: new Date().getTime(),
            formula: "",
            consumption: "",
            is_main: false,
            is_new: true
          }
        ],
      },
      typeOptions: [],
      materialSearchValues: {},
      materialOptions: {},
      materialLoading: {},
      materialSearchTimeouts: {},
    };
  },
  methods: {
    async onMaterialSearch(key, value) {
      this.materialSearchValues[key] = value

      if (!value || value.length < 2) {
        this.materialOptions[key] = []
        this.materialLoading[key] = false
        return
      }
      this.materialLoading[key] = true
      const res = await searchMaterials(value)
      this.materialOptions[key] = res || []
      this.materialLoading[key] = false
    },
    onMaterialSelect(key, row) {
      if (!row) return
      this.updateMaterialByKey(key, 'material_id', row.material_id, row)
      this.materialSearchValues[key] = row.material_name
      this.materialOptions[key] = []
    },
    async getMaterials() {
      const res = await getSetInfo(this.formData.material_set_id);
      this.typeOptions = res || [];
    },
    addMaterial() {
      this.formData.materials.push({
        material_id: "",
        material_id_new: new Date().getTime(),
        formula: " ",
        consumption: "",
        is_main: false,
        is_new: true
      });
    },
    async removeMaterial(key, material_id_new) {
      this.loading = true;
      const idx = this.formData.materials.findIndex(m =>
        (key && m.material_id === key) || (material_id_new && m.material_id_new === material_id_new)
      )
      if (idx === -1) {
        this.loading = false;
        return
      }
      const material = this.formData.materials[idx]

      if (material.is_new) {
        this.formData.materials.splice(idx, 1)
        this.loading = false;
        return
      }

      const payload = {
        material_set_id: this.formData.material_set_id,
        material_id: material.material_id,
      }

      const res = await deleteMaterial(payload)
      this.loading = false;
      if (!res) return;

      this.formData.materials.splice(idx, 1);

      if (this.data?.onUpdateTable) {
        this.data.onUpdateTable(res);
      }
    },
    async onChange(key, value) {
      this.formData[key] = value;
    },
    updateMaterialByKey(key, field, value, row = null) {
      const idx = this.formData.materials.findIndex(m => m.material_id === key || m.material_id_new === key)
      if (idx === -1) return
      this.formData.materials[idx][field] = value;
      if (field === 'material_id' && row) {
        this.formData.materials[idx].material_name = row.material_name;
      }
    },
    async onSubmit() {
      this.loading = true;

      const payload = {
        set_name: this.formData.set_name,
        material_set_id: this.formData.material_set_id,
        materials: this.formData.materials
      };

      await this.data?.onSubmit(payload);
      this.loading = false;
    },
  },
  mounted() {
    this.getMaterials();
  },
};
</script>

<style scoped lang="scss">
.addPackageWrapper {
  max-width: 1500px;

  @media (max-width: 768px) {
    max-width: 100%;
  }
}

.form {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 350px;
  gap: 16px;

  @media (max-width: 428px) {
    min-width: 100%;
  }

  &__item:nth-child(1) {
    width: 500px;
  }

  .addIcon {
    width: 100%;
    display: flex;
    justify-content: end;
    margin-top: 4px;
  }
}

.material-card {
  background: #fafafa;
  border: 1px solid #eaeaea;
  border-radius: 8px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  &__title {
    font-weight: 600;
    font-size: 14px;
    color: #555;
  }
}

.material-card--main {
  background: #f7fbff;
  border-color: #d9ecff;
}

.main-material {
  display: grid;
  grid-template-columns: 1.2fr 0.8fr 0.6fr;
  align-items: center;

  &__name {
    font-size: 14px;
    font-weight: 600;
    color: #1976d2;
  }

  &__detail {
    font-size: 13px;
    color: #666;
  }

  @media (max-width: 680px) {
    grid-template-columns: 1fr;
  }
}

.form-grid {
  display: grid;
  grid-template-columns: 1.2fr 0.9fr 0.6fr auto;
  gap: 12px;
  align-items: end;

  @media (max-width: 920px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
}

.form-grid--main {
  grid-template-columns: 1.2fr 0.9fr 0.6fr;
}

.readonly-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.readonly-label {
  font-size: 12px;
  color: #6b7280;
}

.readonly-value {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 10px 12px;
}

.form__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.unclickable {
  pointer-events: none;
  opacity: 0.5;
}
</style>
